<div class="dlg-hdr">
    <div class="dlg-hdr__title">
        <div class="dlg-hdr__icon-wrap"><mat-icon>{{ error ? 'check' : 'delete' }}</mat-icon></div>
        <div>
            <span>{{ error ? 'Justificante eliminado' : 'Eliminar justificante' }}</span>
            <small class="dlg-hdr__sub" *ngIf="!error">Esta acción no se puede deshacer</small>
        </div>
    </div>
    <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dlg-body">
    <p *ngIf="!error">¿Seguro que quiere eliminar este justificante?</p>
    <p *ngIf="error">El justificante se ha eliminado correctamente.</p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
    <ng-container *ngIf="!error">
        <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
        <button mat-flat-button class="dlg-btn-save" (click)="delete()">
            <mat-icon>delete</mat-icon>
            Eliminar
        </button>
    </ng-container>
    <button mat-flat-button class="dlg-btn-save" (click)="closeDialog()" *ngIf="error">
        <mat-icon>close</mat-icon>
        Cerrar
    </button>
</mat-dialog-actions>
